import WidgetUtils from '../WidgetUtils.js'
import TemplateUtils from './TemplateUtils.js'
const JSApp = {
  type: WidgetUtils.WidgetTypes.JS_APP,
  properties: {
    left: 0,
    top: 0,
    width: 100,
    height: 100,
    mleft: 0,
    mtop: 0,
    mwidth: 100,
    mheight: 100,
    rotation: 0,
    opacity: 0,
    script: '',
    extras: ''
  },
  transition: TemplateUtils.getTransition()
}
export default JSApp



// WEBPACK FOOTER //
// ./src/components/utils/templates/JSApp.js